<template>
    <div class="journey view" id="journey">
        <div class="overview">
            <div class="page-title">
                Journey Report
            </div>
            <div class="filters">
                <div class="filter">
                    <v-menu
                        ref="isDatePickerShow"
                        v-model="isDatePickerShow"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="dateString"
                                label="Picker in menu"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                                outline
                                single-line
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="dateString" @input="dateChanged" no-title scrollable>
                        </v-date-picker>
                    </v-menu>
                </div>
                <div class="filter">
                    <vehicle-autocomplete v-model="vehicle"></vehicle-autocomplete>
                </div>
            </div>
        </div>
        <div class="table">
            <journeys-table :journeys="journeys" @redirect-journey="redirectToJourney"></journeys-table>
        </div>
    </div>
</template>

<script>
import JourneysTable from './JourneysTable'
import VehicleAutocomplete from '../Vehicles/components/VehicleAutocomplete'
import moment from 'moment'
import { JourneyApi, VehicleApi } from '@/api'
import toast from "@/plugins/izitoast";

const vehicleApi = new VehicleApi()
const journeyApi = new JourneyApi()

export default {
    name: 'JourneyReport',
    components: {
        JourneysTable,
        VehicleAutocomplete
    },
    created () {
        this.dateString = moment().format('YYYY-MM-DD')
        this.vehicleUuid = this.$route.query.vehicleUuid || null
    },
    async mounted () {
        this.$store.state.isOverlayActive = true
        if (null !== this.vehicleUuid) {
            await this.getVehicle()
        }
        await this.getJourneys()
        this.$store.state.isOverlayActive = false
    },
    data () {
        return {
            vehicleUuid: null,
            isDatePickerShow: false,
            data: null,
            dateString: null,
            journeys: [],
            vehicle: null
        }
    },
    watch: {
        vehicle: {
            handler: function (value) {
                if (null != value) {
                    this.getJourneys()
                }
            },
            deep: true
        },
        dateString (value) {
            if (null == value) {
                return
            }

            this.getJourneys()
        }
    },
    methods: {
        async getVehicle () {
            const response = await vehicleApi.getVehicle(this.vehicleUuid)
            this.vehicle = response.payload
        },
        async getJourneys () {
            const dateFrom = moment(this.dateString).startOf('d').format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z'
            const dateTo = moment(this.dateString).endOf('d').format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z'

            const response = await journeyApi.getJourneys(dateFrom, dateTo, this.vehicle.id)

            if (!response.isSuccess) {
                return
            }

            if (0 < response.payload.processedJourneys.length) {
                this.journeys = response.payload.processedJourneys
            } else {
                this.journeys = response.payload.unprocessedJourneys
            }
        },
        dateChanged () {
            this.getJourneys()
        },
        redirectToJourney (journey) {
            //todo new redirect to journey
            return
            this.$router.push(`/journeys/${this.vehicle.id}/${journey.id}/${this.dateString}`)
        }
    }
}
</script>

<style scoped lang="scss">
.overview {
    display: flex;
    padding-top: 30px;

    .page-title {
        align-items: center;
        display: flex;
        position: relative;
        top: -12px;
        margin-right: 30px;
        font-weight: bold;
    }

    .filters {
        display: flex;

        .filter {
            margin: 0 10px;
        }
    }
}
</style>
